import * as R from 'ramda'
import { SET_MENU_CONFIG } from 'actions'

export default function menuConfigReducer(state = {}, action) {
  if (action.type === SET_MENU_CONFIG) {
    return R.mergeDeepRight(state, action.config)
  }
  return state
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/menuConfig.js